/**
 * @fileoverview Global page background (splash image + overlay).
 * @summary Used as a unique layer behind all pages for consistent branding.
 * @package PlayItNow
 * @module apps/front/components/PageBackground
 * @author Pierre-Yves Léglise <contact@axialdata.net>
 * @license EULA
 */

import { useLocation } from 'react-router-dom'
import '@/styles/components.css'

/** Routes that use MainPageLayout (split: image left, app right). No global full-screen background. */
const SPLIT_LAYOUT_PATHS = ['/', '/landing', '/login', '/register', '/forgot-password', '/reset-password']

/**
 * @summary Full-viewport background with home page image and overlay.
 * Not rendered on public landing/auth pages (they use MainPageLayout with image on left half only).
 */
export function PageBackground() {
  const { pathname } = useLocation()
  if (SPLIT_LAYOUT_PATHS.includes(pathname)) {
    return null
  }
  return (
    <div className="page-background" aria-hidden>
      <div className="page-background-image" />
      <div className="page-background-overlay" />
    </div>
  )
}
